import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopMetafieldsCreateMutationVariables = Types.Exact<{
  inputs: Array<Types.CreateShopMetafieldInput>;
}>;

export type ShopMetafieldsCreateMutationResponse = Pick<Types.Mutation, 'shopMetafieldsCreate'>;

export const ShopMetafieldsCreateDocument = `
    mutation ShopMetafieldsCreate($inputs: [CreateShopMetafieldInput!]!) {
  shopMetafieldsCreate(inputs: $inputs)
}
    `;

export const useShopMetafieldsCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ShopMetafieldsCreateMutationResponse,
    TError,
    ShopMetafieldsCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ShopMetafieldsCreateMutationResponse,
    TError,
    ShopMetafieldsCreateMutationVariables,
    TContext
  >(
    ['ShopMetafieldsCreate'],
    (variables?: ShopMetafieldsCreateMutationVariables) =>
      appFetcher<ShopMetafieldsCreateMutationResponse, ShopMetafieldsCreateMutationVariables>(
        ShopMetafieldsCreateDocument,
        variables,
      )(),
    options,
  );
};

useShopMetafieldsCreateMutation.getKey = () => ['ShopMetafieldsCreate'];
